import type { GridProps } from '@mui/material';
import { forwardRef } from 'react';

import GridWrapper from '../../wrappers/GridWrapper';

export interface IAtomGridProps extends GridProps {
  /**
   * Selector used by testing-library and Cypress.
   * Consumers remain responsible for semantic roles and ARIA labels.
   * @default 'atom-grid'
   */
  testId?: string;
}

const AtomGrid = forwardRef<HTMLDivElement, IAtomGridProps>(({ testId, children, ...props }, ref) => {
  const {
    'data-testid': dataTestId,
    'data-cy': dataCyAttr,
    ...gridProps
  } = props as IAtomGridProps & { 'data-testid'?: string; 'data-cy'?: string };
  const resolvedTestId = testId ?? dataTestId ?? 'atom-grid';
  const resolvedDataCy = testId ?? dataCyAttr ?? resolvedTestId;

  return (
    <GridWrapper ref={ref} {...gridProps} data-testid={resolvedTestId} data-cy={resolvedDataCy}>
      {children}
    </GridWrapper>
  );
});

AtomGrid.displayName = 'AtomGrid';

export default AtomGrid;
